let floatingTooltip = null;

function showFloatingTooltip(el) {
  if (el.scrollWidth <= el.clientWidth) return;
  const text = el.textContent.trim();
  if (!text) return;

  if (!floatingTooltip || !floatingTooltip.isConnected) {
    floatingTooltip = document.createElement('div');
    floatingTooltip.className = 'loomly-ai-floating-tooltip';
    document.body.appendChild(floatingTooltip);
  }
  floatingTooltip.textContent = text;
  floatingTooltip.style.display = 'block';

  const rect = el.getBoundingClientRect();
  floatingTooltip.style.top = (rect.top + rect.height / 2 - floatingTooltip.offsetHeight / 2) + 'px';
  floatingTooltip.style.left = (rect.right + 8) + 'px';
}

function hideFloatingTooltip() {
  if (floatingTooltip) floatingTooltip.style.display = 'none';
}

function initCalendarSelectorPanel() {
  const toggle = document.querySelector('.js-calendar-panel-toggle');
  const panel = document.getElementById('loomly-ai-calendar-panel');

  if (!toggle || !panel) {
    return;
  }

  if (panel.dataset.initialized === 'true') return;
  panel.dataset.initialized = 'true';

  panel.addEventListener('mouseenter', (e) => {
    const name = e.target.closest('.loomly-ai-calendar-panel-name, .loomly-ai-calendar-group-name');
    if (name) showFloatingTooltip(name);
  }, true);

  panel.addEventListener('mouseleave', (e) => {
    const name = e.target.closest('.loomly-ai-calendar-panel-name, .loomly-ai-calendar-group-name');
    if (name) hideFloatingTooltip();
  }, true);

  toggle.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const isVisible = panel.dataset.visible === 'true';
    panel.dataset.visible = (!isVisible).toString();

    if (!isVisible) {
      toggle.classList.add('active');
    } else {
      toggle.classList.remove('active');
      hideFloatingTooltip();
    }

    if (window.trackPicoUserAction) {
      const uiState = window.getLoomlyAiUiState ? window.getLoomlyAiUiState() : {};
      window.trackPicoUserAction('sidebar_calendar_selector_toggled', { ...uiState, open: !isVisible });
    }
  });

  // Close panel when clicking outside
  document.addEventListener('click', (e) => {
    if (panel.dataset.visible === 'true' &&
      !panel.contains(e.target) &&
      !toggle.contains(e.target)) {
      panel.dataset.visible = 'false';
      toggle.classList.remove('active');
      hideFloatingTooltip();
    }
  });

  // Handle calendar group accordion
  panel.querySelectorAll('.loomly-ai-calendar-group').forEach(group => {
    const header = group.querySelector('.loomly-ai-calendar-group-header');
    const targetId = group.getAttribute('data-target');
    const target = document.querySelector(targetId);

    if (!header || !target) return;

    header.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const isCollapsed = group.classList.contains('collapsed');

      if (isCollapsed) {
        group.classList.remove('collapsed');
        target.classList.add('show');
      } else {
        group.classList.add('collapsed');
        target.classList.remove('show');
      }
    });
  });
}

document.addEventListener('turbo:load', initCalendarSelectorPanel);
document.addEventListener('DOMContentLoaded', initCalendarSelectorPanel);

